import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { ArrowUpperRightIcon } from "@/assets"
import { CurrencyIcon } from "@/helpers/currencyIcon"
import { numberSpaceFixer } from "@/helpers/numberSpaceFixer"
import styles from "./OperationRow.module.scss"
import type { IOperationRow } from "./types"
import { STATUS_META } from "./values"

export const OperationRow: FC<IOperationRow> = ({
  transaction,
  className,
  ...rest
}) => {
  const { t } = useTranslation()
  const { coin, amount, status } = transaction
  const Icon = CurrencyIcon[coin]
  const meta = STATUS_META[status]

  if (!Icon) return null

  return (
    <div {...rest} className={clsx(styles.OperationRow, className)}>
      <div className={styles.OperationRow_left}>
        <div className={styles.OperationRow_iconWrap}>
          <div className={styles.OperationRow_icon}>
            <ArrowUpperRightIcon />
          </div>
          <div
            className={clsx(
              styles.OperationRow_badge,
              styles[meta.badgeClassName]
            )}
          >
            {meta.BadgeIcon && <meta.BadgeIcon />}
          </div>
        </div>
        <div className={styles.OperationRow_info}>
          <div className={styles.OperationRow_title}>
            {t("wallet.withdraw.history.operationType")}
          </div>
          <div className={styles.OperationRow_status}>{t(meta.labelKey)}</div>
        </div>
      </div>
      <div className={styles.OperationRow_right}>
        <span className={styles.OperationRow_sign}>−</span>
        <Icon />
        <span className={styles.OperationRow_amount}>
          {numberSpaceFixer(amount)}
        </span>
      </div>
    </div>
  )
}
